var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.25C12.9062 8.25 13.25 8.59375 13.25 9C13.25 9.4375 12.9062 9.75 12.5 9.75C12.0625 9.75 11.75 9.4375 11.75 9C11.75 8.59375 12.0625 8.25 12.5 8.25ZM13.5 5.5C14.875 5.5 16 6.625 16 8V12C16 12.2812 15.75 12.5 15.5 12.5H13.5V15.5C13.5 15.7812 13.25 16 13 16H3C2.71875 16 2.5 15.7812 2.5 15.5V12.5H0.5C0.21875 12.5 0 12.2812 0 12V8C0 6.625 1.09375 5.5 2.5 5.5V1C2.5 0.46875 2.90625 0 3.4375 0H10.375C10.75 0 11.1562 0.1875 11.4375 0.46875L13.0312 2.0625C13.3125 2.34375 13.5 2.75 13.5 3.125V5.5ZM4 1.5V5.5H12V3.5H10.5C10.2188 3.5 10 3.28125 10 3V1.5H4ZM12 14.5V12.5H4V14.5H12ZM14.5 11V8C14.5 7.46875 14.0312 7 13.5 7H2.5C1.9375 7 1.5 7.46875 1.5 8V11H14.5Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintRed);
export default __webpack_public_path__ + "static/media/printRed.2e76da5d69ee943e6f0d57eea8daedba.svg";
export { ForwardRef as ReactComponent };